import { Arrow } from "../../../../core/icons/ArrowRight";

interface NavigationButtonProps {
	onClick?: () => void;
	className: string;
	ariaLabel: string;
	isReversed?: boolean;
	isBackground?: boolean;
}

export const NavigationButton: React.FC<NavigationButtonProps> = ({ onClick, className, ariaLabel, isReversed = false, isBackground = true }) => {
	return (
		<button
			onClick={onClick}
			className={`transition-colors ease-in-out duration-300 ${isBackground && "bg-white/30 hover:bg-white/50"} 
                w-14 h-14 rounded-full flex justify-center items-center absolute z-10 top-1/2 
                ${className} transform ${isReversed ? "scale-x-[-1]" : ""} -translate-y-1/2`}
			aria-label={ariaLabel}
		>
			<Arrow className="w-2.5" />
		</button>
	);
};
